console.log("Shuffle JS Loaded");

document.addEventListener("click", function (e) {

    const button = e.target.closest("#shuffleProducts");
    if (!button) return;

    e.preventDefault();

    const grid = document.getElementById("AjaxinateContainer");

    if (!grid) {
        console.log("Grid not found");
        return;
    }

    const items = Array.from(
        grid.querySelectorAll(":scope > li.product-grid-item")
    );

    console.log("Products:", items.length);

    if (items.length < 2) return;

    // Fisher-Yates Shuffle
    for (let i = items.length - 1; i > 0; i--) {

        const j = Math.floor(Math.random() * (i + 1));

        [items[i], items[j]] = [items[j], items[i]];

    }

    const fragment = document.createDocumentFragment();

    items.forEach(item => fragment.appendChild(item));

    grid.appendChild(fragment);

    console.log("✅ Shuffled");

});